@if (isShown()) {
  <div
    class="display-flex align-items-center gap-1 ph-4@r pv-1 bg-white box-shadow-lg border-radius-10 t-8@r font-weight-500"
  >
    @if (profile().favorited_by_them) {
      <img class="animated-icon" [src]="'icons/heart.svg' | assetUrl" />

      {{ profile().username }} made you a favorite!
    } @else if (viewedByThemStatus(); as status) {
      <img class="animated-icon" [src]="'icons/vision-eye.svg' | assetUrl" />

      @switch (status) {
        @case ('just_now') {
          They just viewed your profile!
        }
        @case ('recently') {
          They recently viewed your profile!
        }
        @case ('viewed') {
          They’ve viewed your profile!
        }
      }
    }
  </div>
}
